module.exports = __webpack_public_path__ + "img/undraw_launch_day_4e04.23ee41ce.svg";